import { ReactNode } from 'react';

export interface ModalFooterProps {
  children: ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

const alignClasses = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

/**
 * Standardized modal footer with action buttons (responsive)
 */
export function ModalFooter({ children, className = '', align = 'right' }: ModalFooterProps) {
  return (
    <div data-tsx-id="modal-footer" className={`flex flex-col sm:flex-row ${alignClasses[align]} gap-2 sm:gap-3 p-4 sm:p-6 border-t border-zinc-200 bg-zinc-50 ${className}`}>
      {children}
    </div>
  );
}
